<template>
    <div class="faq-container">

        <!-- <div class="faq-header"></div> -->
        <div class="faq-content">

            <div class="faq-item" v-for="(item, index) in faqList" :key="index" :class="item.isActive && `active`">
                <div class="faq-topic" @click="item.isActive = !item.isActive">
                    <h3 class="faq-topic-title">{{ item.title }}</h3>
                    <div class="faq-topic-arrow"><span class="material-symbols-outlined">add</span></div>
                </div>
                <div class="faq-detail" v-html="item.description"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['faqs'],
    data() {
        return {
            faqList: [],
        }
    },

    mounted() {

        this.faqList = this.faqs.map(faq => ({
            ...faq,
            isActive: false,
        }))
        console.log(this.faqs);
    }
}
</script>

<style lang="scss" scoped>
.faq-container {
    padding: 30px 15px;
    max-width: 1240px;
    width: 100%;
    margin: 0 auto;
}

.faq-content {
    background-color: #fff;
}

.faq-topic {
    padding: 24px;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: center;

    cursor: pointer;
}


.faq-topic-title {
    font-size: 22px;
    font-weight: bold;
}

.faq-topic-arrow {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    transition: transform 0.3s ease;
}

.faq-detail {
    font-family: var(--content-font-family);

    transition: all .3s ease-in-out;
    // display: none;
    height: 0;
    padding: 0 24px;
    overflow: hidden;
    opacity: 0;
    visibility: hidden;
}

.faq-item {
    border-top: 1px solid #EEEEEE;

    &.active {

        .faq-topic-arrow{
            transform: rotate(45deg) scale(1.08);
        }
        .faq-detail {
            padding-top: 0;
            padding-bottom: 15px;
            height: auto;
            opacity: 1;
            visibility: visible;
        }
    }
}

@media (min-width: 1240px) {
    .faq-container {
        padding-top: 92px;
        padding-bottom: 92px;
    }
}
</style>